import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatBold(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.6 11.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42ZM10 7.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3Zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
